import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const initialWords = [
    "W",
    "We",
    "Wel",
    "Welc",
    "Welco",
    "Welcom",
    "Welcome",
    "Welcom",
    "Welco",
    "Welc",
    "Wel",
    "We",
    "W",
    "",
    "ආ",
    "ආයු",
    "ආයුබෝ",
    "ආයුබෝව",
    "ආයුබෝවන්",
    "ආයුබෝව",
    "ආයුබෝ",
    "ආයු",
    "ආ",
    "",
    "வ",
    "வண",
    "வணக்",
    "வணக்க",
    "வணக்கம்",
    "வணக்க",
    "வணக்",
    "வண",
    "வ",
    "",
  ];

  const images = ["/images/1.jpeg", "/images/2.jpeg", "/images/3.jpeg"];

  const [wordIndex, setWordIndex] = useState(0);
  const [display, setDisplay] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDisplay(initialWords[wordIndex]);
      setWordIndex((wordIndex + 1) % initialWords.length);
    }, 400);

    return () => clearInterval(intervalId);
  }, [wordIndex]);

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <img src="./images/img1.png" alt="" width="150px" />
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse " id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a className="nav-link" href="#Home">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#ContactUs">
                Contact Us
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#AboutUs">
                About Us
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="d-flex Home" id="Home">
        <div className="row">
          <div className="col-sm homeGridOne">
            <p className="welcome" aria-hidden>
              {display} ! to
            </p>
            <h1>Ruwan Pathirana Automobile</h1>
            <p>
              Revive & Relocate: Your Trusted Carrier Service for Safe Transport
              of Broken or Accident Vehicles. From wreck to recovery, we handle
              it all with care. Swift, secure, and stress-free transport
              solutions for your damaged vehicles, ensuring they reach their
              destination with precision and professionalism.
            </p>
            <a href="tel:+94711334740" className="btn btn-secondary mx-auto">
              <i className="fa fa-phone" aria-hidden="true" /> Contact
            </a>
            <a href="https://wa.me/+94711334740" className="btn btn-success ">
              <i className="fa-brands  fa-whatsapp" aria-hidden="true" />{" "}
              Whatsapp
            </a>
          </div>

          <div className="col-sm homeGridTwo d-flex justify-content-center align-items-center">
            <img
              src={images[currentImageIndex]}
              alt={`Image ${currentImageIndex + 1}`}
              className="img-fluid"
            />
          </div>
        </div>
      </div>

      <div className="ContactUs container text-center" id="ContactUs">
        <h2>Contact US</h2>
        <div className="card mx-auto">
          <img
            src="/images/contact.webp"
            className="card-img-top mx-auto"
            alt="..."
          />
          <div className="card-body">
            <h5 className="card-title">Gaveen Ruwanpath</h5>

            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <i className="fa fa-phone" aria-hidden="true" /> +94 71 133 4740
              </li>
              <li className="list-group-item">
                <i className="fa fa-phone" aria-hidden="true" /> +94 72 665 9326
              </li>
              <li className="list-group-item">
                <i className="fa fa-phone" aria-hidden="true" /> +94 77 765 3233
              </li>
              <li className="list-group-item">
                <i className="fa fa-envelope" aria-hidden="true" />{" "}
                gaveen.buddhila19@gmail.com
              </li>
            </ul>

            <a
              href="https://wa.me/+94711334740"
              className="btn btn-success Dial"
            >
              <i className="fa-brands  fa-whatsapp" aria-hidden="true" />{" "}
              Whatsapp
            </a>
          </div>
        </div>
      </div>

      <div className="container AboutUs " id="AboutUs">
        <h2>About Us</h2>

        <div className="row">
          <div className="col-sm">
            <p>
              Welcome to Revive & Relocate, your premier carrier service based
              in Meepe for the safe transport of damaged vehicles. As proud
              members of the Meepe community, we prioritize swift and secure
              towing solutions, ensuring your vehicles reach their destination
              with care. Our round-the-clock availability, local expertise, and
              commitment to safety set us apart. With state-of-the-art
              equipment, our professional team navigates Meepe's roads
              efficiently, turning challenges into opportunities. At Revive &
              Relocate, we understand the urgency of unexpected incidents, and
              our dedication to precision and professionalism makes us your
              trusted neighbor for stress-free vehicle transport. From wreck to
              recovery, rely on us to handle it all with care.
            </p>
          </div>

          <div className="col-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d314.76466042027545!2d80.09952565725128!3d6.8552841079619915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1
    smaps!5e0!3m2!1sen!2slk!4v1706278106686!5m2!1sen!2slk"
              width="100%"
              height="250"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="map"
            ></iframe>
          </div>
        </div>
      </div>

      <footer className="text-center bg-body-tertiary">
        <div className="container pt-4">
          <section className="mb-4">
            <a
              data-mdb-ripple-init
              className="btn btn-link btn-floating btn-lg text-body m-1"
              href="https://gaveen-recovery.vercel.app/"
              role="button"
              data-mdb-ripple-color="dark"
            >
              <i className="fa-brands fa-google"></i>
            </a>

            <a
              data-mdb-ripple-init
              className="btn btn-link btn-floating btn-lg text-body m-1"
              href="https://www.facebook.com/profile.php?id=61550915780853&mibextid=zOiqff"
              role="button"
            >
              <i className="fa-brands fa-facebook"></i>
            </a>

            <a
              data-mdb-ripple-init
              className="btn btn-link btn-floating btn-lg text-body m-1"
              href="https://www.tiktok.com/@gaveenruwanpathirana...0?_t=8jMDWw74a3u&_r=1"
              role="button"
              data-mdb-ripple-color="dark"
            >
              <i className="fa-brands fa-tiktok" />
            </a>
          </section>
        </div>

        <div className="text-center p-3">
          © 2024 Copyright:
          <a className="text-body" href="https://mdbootstrap.com/">
            {" "}
            RuwanPathirana Automobile
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
